export default __webpack_public_path__ + "static/media/place2.62f28c3f.jpg";